<template>
	<div class="restricted-input">
    <label v-if="fieldLabel">{{fieldLabel}}</label>
    <label class="instructions-label" v-if="instructionsLabel">{{instructionsLabel}}</label>
    <label :data-limit="`${inputValue.length}/${limit}`" :class="getColor()" >
      <input 
        class="restricted-input form-control" 
        v-bind:class="{ 'input-with-label': showLimit }"
        id="primaryInput" 
        type="text" 
        :maxlength="limit" 
        @focus="enableShowLimit"
        @blur="disableShowLimit"
        :placeholder="placeholderText"
        :disabled="isDisabled"
        v-model="inputValue">
    </label>
    <p class="red-text" v-show="inputValue.length === limit && showLimit">{{errorMessage}}</p>
  </div>
</template>

<script>
export default {
  name: 'RestrictedSingleInput',
  props: {
    input: {
      type: String,
      required: true,
      default: '',
    },
    instructionsLabel: {
      type: String,
      required: false,
    },
    fieldLabel: {
      type: String,
      required: false,
    },
    placeholderText: {
      type: String,
      required: false,
      default: '',
    },
    dual: {
      type: Boolean,
      required: false,
      default: false,
    },
    limit: {
      type: Number,
      required: false,
      default: 50,
    },
    warningLimit: {
      type: Number,
      required: false,
      default: 20,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      errorMessage: `You've reached the ${this.limit} characters limit`,
      showLimit: false,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.input;
      },
      set(value) {
        this.$emit('inputUpdated', value);
      },
    },
    charactersRemaining() {
      return this.limit - this.inputValue.length;
    },
  },
  methods: {
    enableShowLimit() {
      this.showLimit = true;
    },
    disableShowLimit() {
      this.showLimit = false;
    },
    getColor() {
      if (!this.showLimit) {
        return 'transparent-text';
      }
      const numberOfCharacters = this.inputValue.length;

      if (numberOfCharacters > 0 && numberOfCharacters <= this.warningLimit) {
        return 'green-text';
      } else if (numberOfCharacters > this.warningLimit && numberOfCharacters < this.limit) {
        return 'yellow-text';
      }
      return 'red-text';
    },
  },
};
</script>

<style scoped>

.green-text {
  color: #558C1D;
}

.yellow-text {
  color: #E58A2D;
}

.red-text {
  color: #8C1D1D;
}

.transparent-text {
  color: transparent;
}

.instructions-label {
  color: #797979;
  font-weight: 300;
  margin-bottom: 10px;
}

label, input {
  position: relative;
  display: block;
  box-sizing: border-box;
}

input {
  color: black !important;
  font-weight: normal !important;
  margin-bottom: 15px !important;
}

.input-with-label {
  padding-right: 42px !important;
}

label::after {
  content: attr(data-limit);
  position: absolute;
  top: 4px;
  right: 5px;
  padding-top: 5px;
  font-size: 12px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// RestrictedSingleInput.vue?f18c7b86